import firebase from '../../../firebase/compat';
import withLinkedStep from '../../../helpers/questionnaire/withLinkedStep';

// Tool handler for the realtime AI interviewer's saveResponse tool call.
// Persists one answer via the saveQuestionnaireResponse Cloud Function
// (dedup + create/update happen server-side; anonymous respondents no longer
// touch Firestore directly), then advances the visual step indicator and
// reports the result back to the realtime session.
const saveResponse = async (
    args,
    call_id,
    questionnaireId,
    client,
    research,
    moment,
    persona,
    timestamp,
    setResponses,
    setFieldIndex,
    eventsRef,
    sendToolResult,
    fields,
    addressStep,
    nameStep
) => {

    const sessionIdLocal = sessionStorage.getItem('sessionId');

    const input = args.input;
    const position = Number(args.position);
    const questionId = args.questionId;
    const questionType = args.questionType;
    const rowId = args.rowId || '';
    const rowTitle = args.rowTitle || '';
    const rowTitleRight = args.rowTitleRight || '';
    const rowPosition = args.rowPosition || '';
    const rowPositionLength = args.rowPositionLength || '';
    const columnId = args.columnId || '';
    const columnTitle = args.columnTitle || '';
    const optionType = args.optionType || '';
    const sectionId = args.sectionId || '';
    const itemId = args.itemId || '';

    const isMatrixType = (t) => t === 'matrix-one' || t === 'matrix-multiple';

    // Optimistic local echo for the step indicator (Firestore doc shape).
    const basePayload = {
        FieldID: questionId,
        FieldTitle: (fields?.find(f => f.ID === questionId)?.Question) || '',
        // ?? en niet ||: het antwoord 0 is een antwoord (#314).
        // AI-CONTEXT: See docs/pitfalls.md#state-or-fallback-erases-zero
        Input: input ?? '',
        Timestamp: timestamp,

        CompagnyID: client,
        QuestionannaireID: questionnaireId,
        QuestionnaireID: questionnaireId,

        MomentID: moment,
        ResearchID: research,

        FormID: sessionIdLocal,
        SessionID: sessionIdLocal,
        SessionId: sessionIdLocal,

        Persona: persona || '',
        OptionType: optionType || '',
        // Per-option identity: with an Itemid, the CF keeps one doc per
        // selected checkbox option instead of collapsing them into one.
        Itemid: itemId || '',
        FieldType: questionType || '',
        SectionID: sectionId || '',
        RowID: rowId || '',
        RowTitle: rowTitle || '',
        RowTitleRight: rowTitleRight || '',
        ColumnID: columnId || '',
        ColumnTitle: columnTitle || '',

        Position: position,
        FieldPosition: position,

        Transcription: eventsRef.current || []
    };

    // Strip the client Timestamp object (not wire-safe); the CF stamps its own
    // from timestampMillis so all answers of one submission share a millisecond.
    const { Timestamp: _clientTimestamp, ...responsePayload } = basePayload;
    const saveResponseFn = firebase.app().functions('europe-west1').httpsCallable('saveQuestionnaireResponse');

    try {
        setResponses(prev => [...prev, { ...basePayload }]);

        await saveResponseFn(withLinkedStep({
        isMatrix: isMatrixType(questionType),
        timestampMillis: timestamp && timestamp.toMillis ? timestamp.toMillis() : undefined,
        response: responsePayload,
        }, { addressStep, nameStep }));

        if (isMatrixType(questionType)) {
            if (rowPosition && rowPositionLength && Number(rowPosition) === Number(rowPositionLength)) {
                setFieldIndex(position);
            }
        } else {
            setFieldIndex(position);
        }

        sendToolResult(call_id, { status: 'saved', questionId, position });
    } catch (err) {
        console.error('Failed to save/update response:', err);
        sendToolResult(call_id, { status: 'error', message: String(err?.message || err) });
    }
};

export default saveResponse;
